/* 
 * To change this license header, choose License Headers in Project Properties.
 * To change this template file, choose Tools | Templates
 * and open the template in the editor.
 */

jQuery('form').submit(function(e, cible_form) {

     // this code prevents form from actually being submitted
     e.preventDefault();
     e.returnValue = false;


    var $form = jQuery(this);

    // this is the important part. you want to submit
    // the form but only after the ajax call is completed
    jQuery.ajax({
         type: 'post',
         url: cible_form, 
         context: $form, // context will be "this" in your handlers
         success: function() { // your success handler
             jQuery('html, body').scrollTop(0);
             jQuery("body").removeClass("loaded");
         },
         error: function() { // your error handler
         },
         complete: function() { 
            // make sure that you are no longer handling the submit event; clear handler
            this.off('submit');
            // actually submit the form
            this.submit();
         }
     });
     
});
